import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { TASK_TYPES } from 'utils/Constants';

import Show from 'components/Show';
import Editor from 'components/Editor';
import Pill from 'components/Misc/Pill';
import { Button } from 'components/Misc/Form';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';

import Upload from 'containers/Student/Exams/Profile/View/Upload';
import Connect from 'containers/Student/Exams/Profile/View/Connect';
import Question from 'containers/Student/Exams/Profile/View/Question';

import { useExamStudentStore } from 'store/exam/useExamStudentStore';

const View = () => {
	// Store current task id
	const { id, taskId } = useParams();

	// Use exam's student store
	const slug = useExamStudentStore(state => state.exam.slug);
	const task = useExamStudentStore(state => state.tasks.find(t => t.id === +taskId));
	const answers = useExamStudentStore(state => state.answers.filter(a => a.taskId === +taskId));

	// Get previous and next tasks for navigation
	const previous = useExamStudentStore(state => state.tasks.find(t => t.order === task.order - 1));
	const next = useExamStudentStore(state => state.tasks.find(t => t.order === task.order + 1));

	// Find type info
	const type = useMemo(() => TASK_TYPES.find(type => type.value === task?.type), [task]);

	return (
		<Container className="p-4 space-y-2">
			{/* Task's title */}
			<div className="flex items-center">
				<Title
					title={`${task?.order}. uzdevums`}
					subtitle={type?.text}
					className="flex-1 text-lg"
				/>

				<Pill name={`${task?.sample * task?.points} punkti`} />
			</div>

			{/* Task's description */}
			<Editor
				readOnly
				path="exams"
				folder={slug}
				value={task?.description}
			/>

			{/* Task's question list */}
			<Show if={task?.type !== 'connect' && task?.type !== 'upload'}>
				<div className="flex flex-col gap-4">
					{answers?.map((question, idx) =>
						<Question
							key={question.id}
							idx={idx}
							type={task.type}
							question={question}
							noTitle={answers?.length <= 1}
						/>
					)}
				</div>
			</Show>

			{/* Connect list */}
			<Show if={task?.type === 'connect'}>
				<Connect answers={answers} />
			</Show>

			{/* Upload list */}
			<Show if={task?.type === 'upload'}>
				<Upload answers={answers} />
			</Show>

			{/* Task's controls */}
			<div className="flex justify-between">
				<Show if={previous?.id}>
					<Button
						icon="arrow_back"
						value="Iepriekšējais"
						to={`/exams/task/${id}/${previous?.id}`}
					/>
				</Show>

				<div className="flex-1"></div>

				<Show if={next?.id}>
					<Button
						icon="arrow_forward"
						value="Nākamais"
						to={`/exams/task/${id}/${next?.id}`}
					/>
				</Show>
			</div>
		</Container>
	);
};

export default View;